export const stockPromoText = {
  title: 'Stok & Promo',
  tabStock: 'Stok Produk',
  tabPromo: 'Promo',
  placeholderStatusStok: 'Pilih status stok',
  placeholderBrand: 'Pilih brand',
  lastSyncText: 'Last Sync',
  placeholderStatusPromo: 'Pilih status promo',
  placeholderShop: 'Pilih toko',
  placeholderSearch: 'Cari...',
};

export const tableStockText = {
  imageText: 'Gambar',
  barcodeText: 'Barcode/SKU',
  productNameText: 'Nama Produk & Brand',
  totalStockText: 'Total Stok',
  warehouseText: 'Gudang',
  stockText: 'Stok Per Gudang',
};

export const modalDetailWarehouseText = {
  title: 'Semua Gudang',
  skuText: 'SKU',
  brandText: 'Brand',
  colWarehouseText: 'Gudang',
  colStockText: 'Stok',
  colStockTooltipText: 'Jumlah stok yang masih tersedia dan siap digunakan',
};

export const tablePromoText = {
  promoStatusTokoText: 'Promo, Status & Toko',
  barcodeText: 'SKU/Barcode',
  productNameText: 'Nama Produk',
  priceText: 'Harga',
  remainingStockText: 'Sisa Stok',
  allocationStockText: 'Alokasi Stok',
  tooltipRemainingStock: 'Jumlah stok yang masih tersedia untuk promo ini',
  tooltipAllocationStock: 'Total stok yang telah dialokasikan untuk promo ini',
  periodePromoText: 'Periode Promo:',
};

export const modalDetailPromoText = {
  title: 'Detail Promo',
  periode: 'Periode',
  shop: 'Toko',
  columnBarcode: 'Barcode/SKU',
  columnProductName: 'Nama Produk',
  columnPrice: 'Harga',
  columnRemainingStock: 'Sisa Stok',
  columnAllocationStock: 'Alokasi Stok',
};
